import { SearchFilter } from "@modules/study/search";
import API from "@unisearch/helpers/api";
import { objectToQueryString } from "@unisearch/helpers/utils";
import { LayoutMain } from "@unisearch/theme/layout";
import React from "react";

const Search = ({
  searchParams,
  location,
  courseLevel,
  specialization,
  examType,
  fees,
  courseDuration,
  filterResult,
  loading,
}) => {
  const params = {
    ...searchParams,
    ...(searchParams.crlvl && { crlvl: searchParams.crlvl.split(",") }),
    ...(searchParams.st && { st: searchParams.st.split(",") }),
    ...(searchParams.sp && { sp: searchParams.sp.split(",") }),
    ...(searchParams.ex && { ex: searchParams.ex.split(",") }),
    ...(searchParams.co && { co: searchParams.co.split(",") }),
    ...(searchParams.ci && { ci: searchParams.ci.split(",") }),
  };

  return (
    <LayoutMain
      title="Search University"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/search`}
    >
      <SearchFilter
        searchParams={params}
        location={location}
        courseLevel={courseLevel}
        specialization={specialization}
        examType={examType}
        fees={fees}
        courseDuration={courseDuration}
        filterResult={filterResult}
        loadings={loading}
      />
    </LayoutMain>
  );
};
export default Search;

//serverside props
export async function getServerSideProps({ query }) {
  let props = {
    searchParams: {},
    location: [],
    courseLevel: [],
    specialization: [],
    examType: [],
    fees: {},
    courseDuration: {},
    filterResult: {},
  };

  // const {
  //   keyword,
  //   keyType,
  //   courseLevels,
  //   exams,
  //   specialization,
  //   duration,
  //   fees,
  // } = context.query;
  // let query = {};

  try {
    //get Location
    await API.get(`/search?${objectToQueryString(query)}`)
      .then((rsp) => {
        if (!rsp.error) {
          const {
            searchParams,
            location,
            courseLevel,
            specialization,
            examType,
            fees,
            courseDuration,
            filterResult,
          } = rsp.data;

          props.searchParams = searchParams ?? {};
          props.location = location ?? [];
          props.courseLevel = courseLevel ?? [];
          props.specialization = specialization ?? [];
          props.examType = examType ?? [];
          props.fees = fees ?? {};
          props.courseDuration = courseDuration ?? {};
          props.filterResult = filterResult ?? {};
        }

        if (rsp.error) {
          // console.log(rsp);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
